import keys from '@debbie/common/dist/cache/keys.js';
import { Entity } from '@debbie/common/dist/index.js';
import { filterPropertyTypes } from '@debbie/common/dist/properties/index.js';
import { getMentionSuggestions, } from '@debbie/common/dist/templates/suggestions.js';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as api from '../api/templates.js';
import { h } from '../index.js';
import { mapLoadable } from '../Loadable/utils.js';
import { usePropertyTypes } from '../properties/index.js';
import q from '../query.js';
import { useTenant } from '../tenant/index.js';
export const templatesEntity = 'templates';
const allTemplatesKey = () => `all-templates`;
export const useTemplates = () => q.query(allTemplatesKey(), () => api.getAll(), keys.read.collection(templatesEntity));
export const useTemplatesMap = () => {
    const templatesLoadable = useTemplates();
    const templates = h.hasData(templatesLoadable) ? templatesLoadable.data : null;
    const map = useMemo(() => {
        if (templates === null) {
            return null;
        }
        const result = {};
        for (const t of templates) {
            result[t.templateId] = t;
        }
        return result;
    }, [templates]);
    return mapLoadable(templatesLoadable, map);
};
// Shared by the interaction composers: the mention suggestions for a template
// type, scoped to the case group's property types.
export const useMentionSuggestions = (templateType, caseGroupId) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    return useMemo(() => templateType
        ? getMentionSuggestions(lang, templateType, propertyTypes
            ? filterPropertyTypes(propertyTypes, Entity.Case, caseGroupId).concat(filterPropertyTypes(propertyTypes, Entity.Customer), filterPropertyTypes(propertyTypes, Entity.Creditor))
            : undefined, tenant)
        : [], [lang, templateType, propertyTypes, caseGroupId, tenant]);
};
//# sourceMappingURL=index.js.map